const BandwidthSlider = Vue.component('bandwidth-slider', {
    name: 'BandwidthSlider',
    template: '#bandwidth-slider',
    props: {
        min: {
            type: [Number, String],
            default: 2,
        },
        max: {
            type: [Number, String],
            default: 5000,
        },
        step: {
            type: [Number, String],
            default: 10,
        },
        val: {
            type: [Number, String],
            default: 2,
        },
    },
    computed: {
        values() {
            /**
             * Add 10 to the max amount because we need to
             * step up in increments of 10 from 0, but we (usually) start at 2
             * so it throws the steps off.
             */
            return {
                value: +this.val,
                min: +this.min,
                max: this.min % +this.max != 0 ? +this.max + 10 : +this.max,
                step: +this.step,
            }
        },
        sliderOpts() {
            const vue = this
            return {
                ...this.values,
                change: function (event, ui) {
                    let val = ui.value - vue.values.min
                    if (val == 0) val = vue.values.min
                    $("#bwslider").val(val)
                    vue.$emit('slide', val)
                    vue.displayVal = val
                },
            }
        }
    },
    methods: {
        valDown: function () {
            if (this.values.value - 100 < this.values.min) {
                $("#bwslider").slider("value", this.values.min);
                this.$emit('slide', this.values.min);
            } else {
                $("#bwslider").slider("value", this.values.value - 100);
                this.$emit('slide', this.values.value - 100);
            }
        },

        valUp: function () {
            if (this.values.value + 100 > (this.values.max - 10)) {
                $("#bwslider").slider("value", (this.values.max - 10));
                this.$emit('slide', (this.values.max - 10));
            } else {
                $("#bwslider").slider("value", this.values.value + 100);
                this.$emit('slide', this.values.value + 100);
            }
        },

        onCommit(event) {
            let newVal = Number(this.val);

            if (newVal < this.values.min) newVal = this.values.min;
            if (newVal > this.values.max) newVal = this.values.max;

            $("#bwslider").slider("value", newVal);
            this.$emit("slide", newVal);
        }
    },
    mounted() {
        $("#bwslider").slider(this.sliderOpts)
        this.$emit('created', this.val)
    }
})